import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-section">
            <h2>SBRAINT</h2>
            <p>
              A Metaverse builder studio that aims to provide digital assets </p>
              <p> and virtual experiences within the metaverse ecosystem.
            </p>
            <div className="social-icons">
              <a href="https://x.com/FacBrosG" target="_blank" rel="noopener noreferrer">
                <img src="/images/twitter.png" alt="Twitter" className="social-icon" />
              </a>
              <a href="https://www.sandbox.game/ko/users/facbros/?tab=Experiences" target="_blank" rel="noopener noreferrer">
                <img src="/images/sandbox.png" alt="The Sandbox" className="social-icon" />
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h2>SUBSCRIBE</h2>
            <p>Enter your email to sign up for our newsletter.</p>
            <p>We promise to respect your inbox.</p>
            <form>
              <input type="email" placeholder="Your email" />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright © 2021-2024 by FacBros.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
